import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const RankingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  ${Styles.BorderStyles}
  ${Styles.FontStyles}
  border-width: 1px;
  overflow: hidden;
`;

export const RankingButton = styled.div`
  text-align: center;
  padding: 2px;
  background-color: ${({ styleProps }) => styleProps?.backgroundColor};
  flex-shrink: 0;
`;

export const RankingList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 5px 0;
  flex-grow: 1;
  overflow-y: auto;
  ${Styles.BorderStyles}
  border-radius: 0;
`;

export const RankingItem = styled.li`
  padding-bottom: 0;
  padding-left: 5px;
`;